import { Box, Divider, Stack, Typography } from '@mui/material';
import React from 'react';

// Themed card-style wrapper for the Reports landing pages.  Mirrors
// the icon-bubble + title + description header used by SettingsSection
// in views/settings/, but local to the reports surface so the two can
// drift independently if the reports layout grows columns or actions.
export default function ReportSection({ icon, title, description, children }) {
  return (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        borderRadius: 1,
        border: 1,
        borderColor: 'divider',
        px: { xs: 2, md: 3 },
        py: 2.5,
        width: '100%',
      }}
    >
      <Stack direction="row" spacing={2} alignItems="center" sx={{ minWidth: 0 }}>
        {icon ? (
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'action.hover',
              color: 'primary.main',
              flexShrink: 0,
              '& svg': { fontSize: 22 },
            }}
          >
            {icon}
          </Box>
        ) : null}
        <Stack spacing={0.25} sx={{ minWidth: 0 }}>
          <Typography variant="h6" component="h2" sx={{ lineHeight: 1.3 }}>
            {title}
          </Typography>
          {description ? (
            <Typography variant="body2" color="text.secondary">
              {description}
            </Typography>
          ) : null}
        </Stack>
      </Stack>
      <Divider sx={{ my: 2 }} />
      <Stack divider={<Divider />}>{children}</Stack>
    </Box>
  );
}
